

<template>
  <div id="app">
    <div id="nav">
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>-->
    </div>
    <router-view />
  </div>
</template>


<script>
export default {
  mounted() {
    // if (this._isMobile()) {
    //   console.log("手机端");
    //   this.$router.replace("/m_index");
    // } else {
    //   console.log("pc端");
    //   this.$router.replace("/");
    // }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  created() {}
};
</script>
<style lang="less">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: "MicrosoftYaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #3b3e43;
  font-size: 14px;
}

#nav {
  a {
    font-weight: bold;
    color: #3b3e43;

    &.router-link-exact-active {
      color: #3b3e43;
    }
  }
}
</style>
